module.exports = __webpack_public_path__ + "img/newLogo1.10f3cf85.png";